import { getApi } from "@beeldit/core/helpers/api";

async function cancelSchedule(endpoint: string, id: number) {
  return getApi().delete(`/${endpoint}/${id}/cancel`);
}

export default cancelSchedule;
